import { useMemo } from 'react';
import { merge } from 'lodash';
import { TUseTablePreserverDecoderConfigs } from '../interfaces';
import useCachedValue from '../../useCachedValue';

const useTablePreserverDecoderCustomConfigMerger = <TConfig, TCustomConfig>(
  config: TUseTablePreserverDecoderConfigs<TConfig>,
  customConfig: TCustomConfig | undefined,
): TUseTablePreserverDecoderConfigs<TConfig> => {
  const cachedConfig = useCachedValue(config);
  const cachedCustomConfig = useCachedValue(customConfig);

  return useMemo(
    () => merge({}, cachedConfig, cachedCustomConfig),
    [cachedConfig, cachedCustomConfig],
  );
};

export default useTablePreserverDecoderCustomConfigMerger;
